import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IN_STORE_RETURN_IMG_SRC } from '@src/assets/images/InStoreReturnImgData';

interface InStoreReturnModalProps {
  onClose: () => void;
  onReturnInStore: () => void;
  onSelectOtherOptions: () => void;
}

const InStoreReturnModal = ({
  onClose,
  onReturnInStore,
  onSelectOtherOptions,
}: InStoreReturnModalProps) => {
  return (
    <Modal open onClose={onClose} data-testid="in-store-return-modal">
      <ModalHeader onClose={onClose}>
        <Typography variant="h4" weight="bold" lineHeight="tight">
          Returning in store?
        </Typography>
      </ModalHeader>
      <ModalBody>
        <div className="sui-flex sui-flex-col sui-gap-4 sui-mb-4 sui-items-start">
          <Typography>
            Show the barcode on your order details for faster in-store returns.
          </Typography>
        </div>
        <div className="sui-w-full sui-bg-[#D9D9D9] sui-pt-[20px] sui-pb-[20px]">
          <div className="sui-w-[206px] sui-m-auto">
            <img
              src={IN_STORE_RETURN_IMG_SRC}
              width={206}
              height={197}
              alt="Order Details"
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div
          className="sui-flex sm:sui-flex-row sm:sui-w-full sui-flex-col-reverse sui-justify-end sui-gap-4 sui-mt-4"
          data-testid="modal-footer"
        >
          <Button
            variant="secondary"
            onClick={onSelectOtherOptions}
            data-testid="modal-action-select-other-options"
          >
            Select other return options
          </Button>
          <Button
            variant="primary"
            onClick={onReturnInStore}
            data-testid="modal-action-return-instore"
          >
            Return In-Store
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default InStoreReturnModal;
